import bilanz from './images/bilanz.jpg';
import dub from './images/dub.jpg';
import bilan from './images/bilan.jpg';
import fia from './images/fia.jpg';
import redherring from './images/redherring.jpg';
import drapers from './images/drapers.jpg';
import prosieben from './images/prosieben.jpg';
import noah17 from './images/noah17.jpg';
import noah16 from './images/noah16.jpg';
import websummit from './images/websummit.jpg';
import fashinvest from './images/fashinvest.jpg';
import fashnerd from './images/fashnerd.jpg';
import nouvo from './images/nouvo.jpg';

export default [
  {
    image: bilanz,
    name: 'bilanz',
    title:
      'Digital Shaper in the category Transformers by Le Temps and BILANZ Wirtschaftsmagazin, 2019',
  },
  {
    image: dub,
    name: 'dub',
    title: 'Featured in Deutsche Unternehmerbörse Magazine, 2019',
  },
  {
    image: bilan,
    name: 'bilan',
    title: 'Selected for Bilan’s list of 50 companies to invest in, 2018',
  },
  {
    image: fia,
    name: 'fia',
    title: 'Winner of Loomish Fashion Innovation Award, 2018',
  },
  {
    image: redherring,
    name: 'redherring',
    title: 'Red Herring Europe Top 100 Companies Winner, 2017',
  },
  {
    image: drapers,
    name: 'drapers',
    title:
      'Finalist: Best App & Best Use of Innovation by Drapers Digital Awards, 2017',
  },
  {
    image: prosieben,
    name: 'prosieben',
    title: 'Featured in Taff Livestream (ProSieben), 2017',
  },
  {
    image: noah17,
    name: 'noah17',
    title: 'Presenting on main stage at NOAH17 in Berlin, 2017',
  },
  {
    image: noah16,
    name: 'noah16',
    title: 'Winner at NOAH16 London Startup, 2016',
  },
  {
    image: websummit,
    name: 'websummit',
    title: 'Featured startup at the Web Summit in Lisbon, 2016',
  },
  {
    image: fashinvest,
    name: 'fashinvest',
    title: 'Top App with FashInvest, 2015',
  },
  {
    image: fashnerd,
    name: 'fashnerd',
    title: 'Top App with FashNerd, NYC, 2015',
  },
  {
    image: nouvo,
    name: 'nouvo',
    title: 'Winner of the 2nd Nouvo Award (lift Conference), 2015',
  },
];
